<template>
	<header :class="type">
		<slot>
			<hero-image :item="headingImage" />
		</slot>
	</header>
</template>

<script setup>
defineProps({
	headingImage: {
		type: Object,
		default: () => ({
			imageWebp: '',
			image: '',
			imageAlt: '',
		}),
	},
	type: {
		type: String,
		default: 'small',
	},
});
</script>

<style lang="scss" scoped>
header {
	position: relative;
}

.index header::after {
	content: '';
	position: absolute;
	width: 100%;
	height: 100%;
	top: 0;
	left: 0;
	background-color: rgb(0 0 0 / 40%);
}

header.large {
	height: 100vh;
}

header.small {
	height: 70vh;
}

@media (max-width: 880px) {
	header.large {
		height: 80vh;
	}

	header.small {
		height: 60vh;
	}
}
</style>
